import { render, staticRenderFns } from "./c_upload_img.vue?vue&type=template&id=5e72c081&scoped=true&"
import script from "./c_upload_img.vue?vue&type=script&lang=js&"
export * from "./c_upload_img.vue?vue&type=script&lang=js&"
import style0 from "./c_upload_img.vue?vue&type=style&index=0&id=5e72c081&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e72c081",
  null
  
)

export default component.exports